import './CSS/App.scss';
import 'normalize-css';
import Header from './COMPONENTS/Header';
import Map from './COMPONENTS/Map';
import Loading from './COMPONENTS/Loading';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { IP_BASE_URL, IP_INFO_BASE_URL } from './CONFIG/Config';

function App() {
	const [ipInfo, setIpInfo] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	async function fetchIpInfo(ipOrDomain) {
		try {
			setErrorMessage('');
			const { data: ipInfo } = await axios(
				`${IP_INFO_BASE_URL}${process.env.REACT_APP_IP_INFO_API_KEY}&domain=${ipOrDomain}`
			);
			setIpInfo(ipInfo);
		} catch (error) {
			console.log(error.message);
			setErrorMessage('No result found');
		}
	}

	// SET DEFAULT IP TO USERS IP
	useEffect(() => {
		(async function () {
			const {
				data: { ip: userIp },
			} = await axios(`${IP_BASE_URL}${process.env.REACT_APP_IP_API_KEY}`);

			fetchIpInfo(userIp);
		})();
	}, []);

	return (
		<div className="app">
			<Header
				ipInfo={ipInfo}
				fetchIpInfo={fetchIpInfo}
				errorMessage={errorMessage}
			/>
			{ipInfo ? <Map ipInfo={ipInfo} /> : <Loading />}
		</div>
	);
}

export default App;
